<template style="background-color:#f5f5f5;">
  <div class="personmanage">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="7" class="x-person-left">

        <!-- <div class="grid-content bg-purple">
          <div class="x-per-lebg">组织
            <div class="x-person-name" @click="allperson">{{company}}</div>
          </div>
          <ul style="height:520px;overflow-y:auto;">
            <li class="x-per-li" v-if="showclasslist.length != 0" v-for="item in showclasslist" :key="item.key" @click="changegroup(item.id)">
              <div class="x-perli-item">{{item.title}}</div>
              <div class="x-perli-item"><span>{{item.num}}</span>人</div>
              <el-button type="text" class="x-perli-item x-font-danger" @click.stop="deldepart(item.id)">删除</el-button>
            </li>
            <div class="x-nothing" v-else>快去添加部门吧</div>
          </ul>
          <div class="x-btn x-btn-bl x-person-btn" @click="editdepart"><span class="x-ac-modyfy"></span>管理部门</div>
        </div> -->
        <!-- 添加部门 -->
        <el-dialog width="30%" title="请输入名称" :visible.sync="innerVisible" append-to-body :close-on-click-modal='noshowmodal'>
          <el-input v-model="subsetname" :disabled="isdisabled" class="x-input-box" clearable></el-input>
          <div class="x-desc" v-show="subsetnoname">请输入名称5</div>
          <div slot="footer" class="dialog-footer x-css-footer">
            <div class="x-btn x-btn-bl" @click="innerVisible=false;addsubset()">确定</div>
          </div>
        </el-dialog>

        <el-dialog width="30%" title="请输入新名称" :visible.sync="innerVisibletwo" append-to-body :close-on-click-modal='noshowmodal'>
          <el-input v-model="newname" :disabled="isdisabled" class="x-input-box" clearable></el-input>
          <div class="x-desc" v-show="nonewname">请输入名称</div>
          <div slot="footer" class="dialog-footer x-css-footer">
            <div class="x-btn x-btn-bl" @click="innerVisibletwo=false;changetreename()">确定</div>
          </div>
        </el-dialog>
        <el-tabs v-model="activeName" @tab-click="" :stretch="true">
          <el-tab-pane label="人事管理" name="first">
            <div class="x-tree-title">元乐培训人员管理<span @click="addbranch=true">添加</span></div>
            <div class="x-addclass-box">
              <div class="custom-tree-container">
                <el-tree :data="treedata" node-key="id" ref="tree" highlight-current :props="defaultProps" :render-content="renderContent" :default-expanded-keys="departmenttreeexpanded" @node-click="clicktree"></el-tree>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="培训班管理" name="second">
            <ul style="height:460px;overflow-y:auto;">
              <li class="x-per-li" v-if="traindata != ''" v-for="item in traindata" :key="item.key" @click="trainuser(item.id)">
                <div class="x-teac-l">
                  {{item.title}}
                </div>
                <div class="x-teac-r">
                  <!-- <el-button type="text" class="x-perli-item" @click.stop="trainadd(item.id)" style="color:#BDA17A">添加成员</el-button> -->
                  <el-button type="text" class="x-perli-item" @click.stop="trainedit(item)" style="color:#BDA17A">编辑</el-button>
                  <el-button type="text" class="x-perli-item x-font-danger" @click.stop="trainremove(item.id,item.title)">删除</el-button>
                </div>

              </li>
              <div class="x-nothing" v-else>还没有培训班哦</div>
              <div class="x-btn x-btn-bl x-person-btn" @click="addtraintoast=true;isaddtrain=true;isedittrain=false;"><span class="x-ac-addbtn"></span>添加培训班</div>
            </ul>


          </el-tab-pane>
          <el-tab-pane label="区域店面管理" name="three">
            <div class="x-btn x-btn-bl" @click="addstoretoast=true;isstore=false;isaddstore=true"><span class="x-ac-modyfy"></span>添加区域</div>
            <div class="x-addclass-box">
              <div class="custom-tree-container">
                <el-tree :data="treedatastore" node-key="id" ref="tree" highlight-current :props="defaultProps" :render-content="renderContenttwo" @node-click="clicktreetwo"></el-tree>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div slot="footer" class="dialog-footer x-css-footer">
          <div class="x-btn x-btn-bl" @click="edit=false">确定</div>
        </div>

      </el-col>
      <el-col :span="15"><div class="grid-content bg-purple-light x-person-right">
        <div class="x-per-right">
          <!-- <el-tooltip effect="dark" content="点击显示全体人员列表" placement="top"> -->
            <div class="x-ri-title" @click="allperson">全体人员 ({{tableDatalength}})人</div>
            <div class="x-btn-right">
              <el-input v-model="searchuser" placeholder="输入人员姓名" class="x-search-input" clearable @clear="clearsearch"></el-input>
              <span class="x-btn" @click="gosearch"><span class="x-search-icon"></span>搜索</span>
            </div>
          <!-- </el-tooltip> -->
          <!-- 按钮组 -->
          <div class="x-all-btn">
            <div class="x-btn-left">
              <div class="x-btn x-btn-bl" @click="addusermax"><span class="x-ac-modyfy"></span>添加成员</div>
              <div class="x-btn x-btn-bl" @click="addtotraintoast=true"><span class="x-icon-go"></span>添加到培训班</div>
              <!-- <div class="x-btn x-btn-bl" @click="removetablelist('','0')"><span class="x-icon-remove"></span>批量删除</div> -->
            </div>

          </div>
          <img src="../images/back.png" alt="" class="x-back-per" v-show="backisshow" @click="allperson">
          <el-table :data="tableData" style="width: 100%;height:623px;overflow-y:scroll;" @selection-change="handleRowChange" ref="multipleTable" @row-click="clickrow">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column label="姓名" width="">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.username }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="职位" width="">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.job_title }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="所属组织" width="100">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.bread }}</span>
              </template>
            </el-table-column>
            <el-table-column label="联系方式" width="150">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.phone }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="340">
              <template slot-scope="scope">
                <!-- <el-button size="mini" @click.stop="seepersondesc(scope.row.id)">查看个人资料</el-button> -->
                <router-link :to="{name:'persondesc',params:{id:scope.row.id}}" class="x-per-descc">
                  <span class="x-ac-addbtn"></span>查看个人资料
                </router-link>
                <el-button size="mini" @click.stop="edittablelist(scope.row)">编辑</el-button>
                <el-button size="mini" type="" @click.stop="removetablelist(scope.row.id,'1')" v-show="notraindelete">删除</el-button>
                <el-button size="mini" type="" @click.stop="removetablelisttrain(scope.row.rowid,'1')" v-show="yestraindelete">从培训班删除</el-button>
                <!-- <span class="x-ac-modyfy" @click.stop="edittablelist(scope.row)">编辑</span>
                <span class="x-ac-remove" @click.stop="removetablelist(scope.row.id,'1')">删除</span> -->
              </template>
            </el-table-column>
          </el-table>

        </div>
      </div></el-col>
    </el-row>
    <!--添加部门弹窗-->
    <el-dialog title="添加部门" :visible.sync="addbranch" class="x-addb-hed" :close-on-click-modal='noshowmodal'>
      <div class="x-addclass-box">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="部门名称">
            <el-input v-model="form.name" clearable></el-input>
            <div class="x-desc" v-show="desctwo">请输入部门名称</div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="x-btn x-btn-bl" @click="adddepart">添加</div>
      </div>
    </el-dialog>
    <!--添加区域和店面弹窗-->
    <el-dialog title="添加区域或店面" :visible.sync="addstoretoast" class="x-addb-hed" :close-on-click-modal='noshowmodal'>
      <div class="x-addclass-box">
        <el-form ref="storeform" :model="storeform" label-width="80px">
          <el-form-item label="区域或店面名称">
            <el-input v-model="storeform.name" clearable></el-input>
            <div class="x-desc" v-show="storedesctwo">请输入区域名称</div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="x-btn x-btn-bl" @click="addstore('0')" v-show="isaddstore">添加</div>
        <div class="x-btn x-btn-bl" @click="editstore" v-show="!isaddstore">修改</div>
      </div>
    </el-dialog>
    <!--编辑部门弹窗-->
    <el-dialog title="编辑" :visible.sync="edit" class="x-addb-hed" :close-on-click-modal='noshowmodal'>

      <el-dialog width="30%" title="请输入名称" :visible.sync="innerVisible" append-to-body :close-on-click-modal='noshowmodal'>
        <el-input v-model="subsetname" :disabled="isdisabled" class="x-input-box" clearable></el-input>
        <div class="x-desc" v-show="subsetnoname">请输入名称2</div>
        <div slot="footer" class="dialog-footer x-css-footer">
          <div class="x-btn x-btn-bl" @click="innerVisible=false;addsubset()">确定</div>
        </div>
      </el-dialog>

      <el-dialog width="30%" title="请输入新名称3" :visible.sync="innerVisibletwo" append-to-body :close-on-click-modal='noshowmodal'>
        <el-input v-model="newname" :disabled="isdisabled" class="x-input-box" clearable></el-input>
        <div class="x-desc" v-show="nonewname">请输入名称3</div>
        <div slot="footer" class="dialog-footer x-css-footer">
          <div class="x-btn x-btn-bl" @click="innerVisibletwo=false;changetreename()">确定</div>
        </div>
      </el-dialog>
      <div class="x-tree-title">{{company}}<span @click="addbranch=true">添加</span></div>
      <div class="x-addclass-box">
        <div class="custom-tree-container">
          <el-tree :data="treedata" node-key="id" ref="tree" highlight-current :props="defaultProps" :render-content="renderContent" :default-expanded-keys="departmenttreeexpanded"></el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer x-css-footer">
        <div class="x-btn x-btn-bl" @click="edit=false">确定</div>
      </div>
    </el-dialog>
    <!--添加成员弹窗-->
    <el-dialog title="添加成员" :visible.sync="addusertoast" class="x-addb-hed" :close-on-click-modal='noshowmodal' :destroy-on-close='destroyonclose'>
      <div class="x-addclass-box">
        <el-form :model="adduserform" label-width="100px" :rules="rules" ref="ruleForm">
          <!-- <el-form-item label="所属部门:" prop="depart">
              <el-select v-model="adduserform.depart" clearable placeholder="请选择" size="large" style="width:100%" @change="changeselect">
                <el-option v-for="item in showclasslist" :key="item.id" :label="item.title" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="职位:" prop="position">
            <el-select v-model="adduserform.position" clearable placeholder="请选择" size="large" style="width:100%" @change="changeposition">
              <el-option v-for="item in showdepartlist" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系方式:" prop="tel" >
            <el-input v-model="adduserform.tel" clearable size="large"></el-input>
            <div class="x-desc" v-show="desctel">请输入联系方式</div>
          </el-form-item> -->
          <el-form-item label="姓名：" prop="name" label-width="120px">
            <el-input v-model="adduserform.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="人事管理组织:" prop="depart" label-width="120px">
            <el-tree :data="treedata" ref="treeForm" @check-change="orgCheckChangeadd" show-checkbox :check-strictly="true" node-key="id" :props="defaultProps"></el-tree>
          </el-form-item>
          <el-form-item label="联系方式：" prop="tel" label-width="120px">
            <el-input v-model="adduserform.tel" clearable></el-input>
          </el-form-item>
          <el-form-item label="性别:" label-width="120px" prop="gender">
            <el-radio-group v-model="adduserform.gender">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="入职时间:" label-width="120px" prop="date1">
            <el-date-picker v-model="adduserform.date1" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="店面选择:" label-width="120px" prop="">
            <el-select v-model="edituserform.area" placeholder="请选择" @change="areaget">
              <el-option
                v-for="item in treedatastore"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="edituserform.areatwo" placeholder="请选择" @change="areagettwo">
              <el-option
                v-for="item in areadata"
                :key="item.title"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限：" label-width="120px">
            <!-- <el-checkbox v-model="logarr">查看他人日志</el-checkbox> -->
            <div class="x-addclass-box">
              <div class="custom-tree-container">
                <el-tree :data="treedata" :default-expand-all='showba' :check-strictly='showba' show-checkbox node-key="id" ref="treeeditref" highlight-current :props="defaultProps" @check-change="handleCheckChange" :default-checked-keys="treechecknow" :default-expanded-keys="treeexpanded"></el-tree>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="x-btn x-btn-bl" @click="submitForm('ruleForm')">添加</div>
      </div>
    </el-dialog>
    <!--编辑成员弹窗-->
    <el-dialog title="编辑成员" v-if="addDialogVisible" :visible.sync="editusertoast" class="x-addb-hed" :close-on-click-modal='noshowmodal' :destroy-on-close='destroyonclose'>
      <div class="x-addclass-box">
        <el-form :model="edituserform" label-width="100px" :rules="rules" ref="ruleForm">
          <el-form-item label="姓名：" prop="name" label-width="120px">
            <el-input v-model="edituserform.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="人事管理组织:" prop="depart" label-width="120px">
            <el-tree :data="treedata" ref="treeForm" @check-change="orgCheckChangeadd" show-checkbox :check-strictly="true" node-key="id" :props="defaultProps" :default-checked-keys="morenchecken" :default-expanded-keys="morenshow"></el-tree>
          </el-form-item>
          <el-form-item label="联系方式：" prop="tel" label-width="120px">
            <el-input v-model="edituserform.tel" clearable></el-input>
          </el-form-item>
          <el-form-item label="性别:" label-width="120px" prop="gender">
            <el-radio-group v-model="edituserform.gender">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="入职时间:" label-width="120px" prop="date1">
            <el-date-picker v-model="edituserform.date1" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="店面选择:" label-width="120px" prop="">
            <el-select v-model="edituserform.area" placeholder="请选择" @change="areaget">
              <el-option
                v-for="item in treedatastore"
                :key="item.title"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="edituserform.areatwo" placeholder="请选择" @change="areagettwo">
              <el-option
                v-for="item in areadata"
                :key="item.title"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限：" label-width="120px">
            <div class="x-addclass-box">
              <div class="custom-tree-container">
                <el-tree :data="treedata" :default-expand-all='showba' :check-strictly='showba' show-checkbox node-key="id" ref="treeeditref" highlight-current :props="defaultProps" @check-change="handleCheckChange" :default-checked-keys="treechecknow" :default-expanded-keys="treeexpanded"></el-tree>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="x-btn x-btn-bl" @click="edituserok('ruleForm')">确定</div>
      </div>
    </el-dialog>
    <!--添加培训班弹窗-->
    <el-dialog title="添加培训班" :visible.sync="addtraintoast" class="x-addb-hed" :close-on-click-modal='noshowmodal' :destroy-on-close='destroyonclose'>
      <div class="x-addclass-box">
        <el-form :model="trainform" label-width="100px" :rules="rulestrain" ref="ruleForm">
          <el-form-item label="培训班名称：" prop="name" label-width="120px">
            <el-input v-model="trainform.name" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="isaddtrain">
        <div class="x-btn x-btn-bl" @click="addtrain('ruleForm')">添加</div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="isedittrain">
        <div class="x-btn x-btn-bl" @click="edittrain">编辑</div>
      </div>
    </el-dialog>
    <!--添加部门弹窗-->
    <el-dialog title="添加培训班人员" :visible.sync="addtraintoastuser" class="x-addb-hed" :close-on-click-modal='noshowmodal'>
      <div class="x-addclass-box">
        <el-form ref="trainaddform2" :model="trainaddform" label-width="" :rules="trainaddform2">
          <el-form-item label="请选择学员" prop="type">
            <el-checkbox-group v-model="trainaddform.type" @change="gettrainusername">
              <el-checkbox :label="item.id" v-for="item in tableDatatrain" :key="item.id">{{item.username}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="x-btn x-btn-bl" @click="adddepartuser('trainaddform2')">添加</div>
      </div>
    </el-dialog>
    <!-- 添加人员到培训班 -->
    <el-dialog title="添加到培训班" :visible.sync="addtotraintoast" class="x-addb-hed" :close-on-click-modal='noshowmodal'>
      <div class="x-addclass-box">
        <el-select v-model="addtotrainid" placeholder="请选择">
          <el-option
            v-for="item in traindata"
            :key="item.title"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="x-btn x-btn-bl" @click="addtotrain">添加</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'personmanage',
  data () {
    return {
      addtotraintoast:false,
      trainaddform:{
        type:[]
      },
      trainaddform2:{
        type: [
          { type: 'array', required: true, message: '请至少选择一个成员', trigger: 'change' }
        ]
      },
      edittrainid:'',
      isaddtrain:false,
      isedittrain:false,
      trainform:{
        name:''
      },
      addtraintoast:false,
      addbranch:false,
      addcll:'',
      desc:false,
      showclasslist:'',
      modifytitle:'',
      modifyinput:'',
      modifyok:'',
      desctwo:false,
      addclassloading:false,
      form:{
        name:''
      },
      edit:false,
      formtwo:{
        name:'',
        position:''
      },
      descthree:false,
      departid:'',//部门id
      positionid:'',//职位id
      isdisabled:false,
      ischangebtn:true,
      isdisabledtwo:false,
      descfour:false,
      isaddpositionbtn:true,
      showdepartlist:'',
      isshowpositiontitle:true,
      isshowpositiondesc:false,
      tableData:[{

      }],
      allmainproloading:true,
      searchuser:'',
      addusertoast:false,
      adduserform:{
        name:'',
        tel:'',
        date1:'',
        log:[],
        gender:'',
        date1:''
      },
      edituserform:{
        name:'',
        tel:'',
        date1:'',
        log:[],
        gender:'',
        date1:'',
        area:'',
        areatwo:''
      },
      desctel:false,
      rulestrain:{
        name: [
          { required: true, message: '请输入培训班名称', trigger: 'blur' }
        ]
      },
      rules: {
        name: [
          { required: true, message: '请输入人员姓名', trigger: 'blur' },
          { min: 2, max: 4, message: '长度在 2 到 4 个字', trigger: 'blur' }
        ],
        depart: [
          // { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
          // { required: true, message: '请输入职位', trigger: 'blur' }
        ],
        position: [
          { required: true, message: '请选择职位', trigger: 'change' }
        ],
        tel: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        gender:[
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        date1:[
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ]
      },
      ruleForm: {
          name: '',
          depart: '',
          position: '',
          tel: '',
          gend:'',
          date1:''
        },
      tablelist:'',
      editusertoast:false,
      userlistid:'',//人员数据id
      flag:false,
      company:localStorage.company,
      checkeduserid:[],
      max_num:'',
      all_num:0,
      innerVisible:false,
      subsetname:'',
      subsetnoname:false,
      showdepartlistthree:'',
      numnumthree:'',
      placetitle:'',
      treedata:[],
      defaultProps: {
          children: '_child',
          label: 'title'
        },
      treeappendid:'',
      innerVisibletwo:false,
      nonewname:'',
      newname:'',
      treedeitid:'',
      selectOrg: {
        orgsid: []
      },
      treechecknow:[],
      treechecknowtwo:[],
      treeexpanded:[],
      noshowmodal:false,
      departmenttreeexpanded:[],
      destroyonclose:true,
      addDialogVisible:true,
      backisshow:false,
      i:0,
      morenchecken:[],//编辑人员 默认勾选
      morenshow:[],
      activeName:'first',
      traindata:'',
      trainadduserid:[],
      addtrainid:'',
      tableDatatrain:[],
      addtraintoastuser:false,
      showba:true,
      logarr:[],
      persondata:[],//个人资料
      addtotrainid:'',//添加到培训班 培训班id
      notraindelete:true,
      yestraindelete:false,
      traindeleteuserid:'',//删除培训班人员时的培训班id
      tableDatalength:'',
      addstoretoast:false,
      isstore:false,
      isaddstore:true,
      treedatastore:[],
      storeform:{
        name:'',
      },
      storedesctwo:false,
      areadata:'',
    }
  },
  created() {
    // this.classlist()//部门列表
    this.userlist()//人员列表
    this.tree()
    this.trainlist()//培训班列表
    this.trainuserlist()//培训班成员列表
    console.log(Array.isArray(this.logarr));
    this.getstoredata()
  },
  methods: {
    //区域》店面
    areaget:function(val){
      console.log(val);
      for(var i=0;i<this.treedatastore.length;i++){
        if(this.treedatastore[i].id==val){
          this.areadata = this.treedatastore[i]._child;
        }
        console.log(this.areadata);
      }
    },
    //店面选择
    areagettwo:function(val){
      console.log(val);
      this.areaid=val;
    },
    //区域与店面列表
    getstoredata:function(){
      axios.get('/admin/region/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.treedatastore = response.data.data;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //
    handleCheckChange(data, checked, indeterminate){
      console.log('数据:',data,'选中状态:',checked,'子树中选中状态:',indeterminate)
      console.log(JSON.stringify(this.logarr));
      console.log(Array.isArray(this.logarr));
      const indexs = this.logarr.indexOf(data.id);
      console.log(indexs);//-1 没包含
      // const indexnum = data._child.length;
      // console.log(indexnum);
      var that = this;
      console.log(data.id);
      // that.logarr=[]
      // console.log(data._child.length);
      // if(checked){
      //   if(data._child){//有子集
      //     for(var i=0;i<data._child.length;i++){
      //       if(that.logarr.indexOf(data._child[i].id)){//如果没有
      //         console.log('没有这个id'+i);
      //         console.log(that.logarr.indexOf(data._child[i].id));
      //
      //         that.logarr.push(data._child[i].id)
      //       }else{
      //         console.log(that.logarr);
      //         console.log(data._child[i].id);
      //         console.log('已经有这个id了');
      //       }
      //
      //     }
      //   }else{
      //     that.logarr.push(data.id)
      //   }
      //
      // }else{
      //   that.logarr.splice(indexs,indexnum)
      // }
      // ////////////////////////////////////////////
      if(checked && indexs<0){
        console.log(that.logarr);
        that.logarr.push(data.id)
      }else if(!checked && indexs>=0){
        that.logarr.splice(indexs,1)
      }

      console.log("传参用id:"+that.logarr);
    },
    gosearch(){
      if(!this.searchuser){
        this.$message({
          showClose: true,
          message: '搜索的关键词不能为空哦',
          type: 'warning'
        });
      }else{
        this.backisshow=true
        axios.get('/admin/member/search', {
          params: {
            sec: localStorage.token,
            key:this.searchuser
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
              // console.log(response.data.data.list);
              if(response.data.data.list.length==''){//没有相关结果
                  this.tableData = response.data.data.list;
                  this.tableDatalength = response.data.data.list.length;//table数据源
              }else{//有
                this.tableData = response.data.data.list;
                this.tableDatalength = response.data.data.list.length;//table数据源
              }
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    clearsearch(){
      this.userlist()//人员列表
    },
    clicktree(data,node,my){
      console.log(data);
      console.log(node);
      console.log(my);
      this.notraindelete = true;
      this.yestraindelete = false;
      this.allmainproloading = true;
      this.userlist(data.id)
    },
    //点击区域和店面 树
    clicktreetwo(data,node,my){
      console.log(data);
      console.log(node);
      console.log(my);
      if(data.pid=='0'||data.pid==0){

      }else{
        this.getstoreuser(data.id)
      }
      this.notraindelete = true;
      this.yestraindelete = false;
      this.allmainproloading = true;

    },
    // 区域店面管理   >   人员列表
    getstoreuser(departid){
      console.log('人员列表接的参数：'+departid);
      axios.get('/admin/member/regionList', {
        params: {
          sec: localStorage.token,
          regionId:departid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.allmainproloading = false;//取消加载框
            this.tableData = response.data.data.list;//table数据源
            this.tableDatalength = response.data.data.list.length;//table数据源
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //添加区域和店面1
    storetreeadd:function(data){
      // console.log(data.id);
      this.addstoretoast = true;
      this.isaddstore = true;//切换按钮
      this.isstore = true;//店面还是区域 true店面 false区域
      this.storeid = data.id
    },
    //添加区域和店面2
    addstore:function(){
      if(this.storeform.name == ''){
        this.storedesctwo = true;
      }else{
        console.log(this.storeid);
        console.log(this.isstore);
        if(this.isstore){
          this.pidpid=this.storeid
        }else{
          this.pidpid='0'
        }
        console.log(this.pidpid);
        this.storedesctwo = false;
        // this.addclassloading=true;
        axios.get('/admin/region/add', {
          params: {
            sec: localStorage.token,
            title:this.storeform.name,
            pid:this.pidpid
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
            this.addstoretoast = false;
            // this.addclassloading = false;
              // this.addcll = ''
              this.storeform.name = ''
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success'
              });
              // this.classlist()
              this.getstoredata()
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    //编辑 区域和店面1
    storetreeedit:function(node,data){
      console.log(data.title);
      this.addstoretoast = true;
      this.isaddstore = false;//切换按钮
      this.storeform.name = data.title;
      this.editstoreid = data.id;
    },
    //确认编辑 区域和店面2
    editstore:function(){
      if(this.storeform.name == ''){
        this.storedesctwo = true;
      }else{
        this.storedesctwo = false;
        // this.addclassloading=true;
        axios.get('/admin/region/edit', {
          params: {
            sec: localStorage.token,
            id:this.editstoreid,
            title:this.storeform.name
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
              this.addstoretoast = false;
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
              });
              this.getstoredata()
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    //删除区域或店面
    treeremovestore:function(node,data){
      console.log(data.id);
      this.$confirm('确定要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/region/del', {
            params: {
              sec: localStorage.token,
              id:data.id
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getstoredata()
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    // check-change
    // 节点选中状态发生变化时的回调
    // 共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点本身是否被选中、节点的子树中是否有被选中的节点
    // 点击添加 树
    orgCheckChangeadd(data, checked, indeterminate){
      console.log(data, '数据')
      console.log(checked, '选中状态')
      console.log(indeterminate, '子树中选中状态')
      // this.$nextTick(() => {
      // 	this.$refs.treeeditref.setCheckedKeys([]);
      // });
      this.i++;
      if(this.i%2===0){
          if(checked){
              this.$refs.treeForm.setCheckedNodes([]);
              this.$refs.treeForm.setCheckedNodes([data]);
              //交叉点击节点
          }else{
              this.$refs.treeForm.setCheckedNodes([]);
              //点击已经选中的节点，置空
          }
      };
      if(checked){
        this.selectOrg.orgsid = []
        this.selectOrg.orgsid.push(data.id)
        console.log(this.selectOrg.orgsid);
        this.positionid=data.id
        console.log(this.positionid);
      }
    },
    // 点击编辑 树
    orgCheckChange(data, checked, indeterminate){
      console.log(data, '数据')
      console.log(checked, '选中状态')
      console.log(indeterminate, '子树中选中状态')
      // this.$nextTick(() => {
      // 	this.$refs.treeeditref.setCheckedKeys([]);
      // });
      if(checked){
        this.selectOrg.orgsid = []
        this.selectOrg.orgsid.push(data.id)
        console.log(this.selectOrg.orgsid);
        this.positionid=data.id
        console.log(this.positionid);
        this.$refs.treeeditref.setCheckedNodes([data]);
      }
    },
    aorgCheckChange(data, checked, indeterminate) {
       console.log(data, '数据')
       console.log(checked, '选中状态')
       console.log(indeterminate, '子树中选中状态')
       // 获取当前选择的id在数组中的索引
       const indexs = this.selectOrg.orgsid.indexOf(data.id);
       console.log('indexs'+indexs);
       console.log(this.selectOrg.orgsid.length);
       // 如果不存在数组中，并且数组中已经有一个id,并且checked为true的时候，代表不能再次选择。
       if (indexs < 0 && this.selectOrg.orgsid.length === 1 && checked) {
         console.log('only one')
         // this.$message({
         //   message: '只能选择一个部门！',
         //   type: 'error',
         //   showClose: true
         // })
         // 设置已选择的节点为false 很重要
         this.$refs.treeeditref.setChecked(treedata, false)
       } else if (this.selectOrg.orgsid.length === 0 && checked) {
         // 发现数组为空 并且是已选择
         // 防止数组有值，首先清空，再push
         this.selectOrg.orgsid = []
         this.selectOrg.orgsid.push(data.id)
         console.log(this.selectOrg.orgsid);
         this.positionid=data.id
         console.log(this.positionid);
       } else if (
         indexs >= 0 &&
         this.selectOrg.orgsid.length === 1 &&
         !checked
       ) {
         console.log('直接清空');
         // 再次直接进行赋值为空操作
         this.selectOrg.orgsid = []
       }
     },
    // 部门列表
    classlist(){
      axios.get('/learn/organization/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            // console.log(response.data.data.list);
            this.showclasslist = response.data.data.list;//部门列表数据
            this.max_num = response.data.data.max_num;//最大人员数
            for(var i=0;i<response.data.data.list.length;i++){
              this.all_num += parseInt(response.data.data.list[i].num);
            }
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 添加部门
    adddepart(){
      if(this.form.name == ''){
        this.desctwo = true;
      }else{
        this.desctwo = false;
        this.addclassloading=true;
        axios.get('/admin/structure/add', {
          params: {
            sec: localStorage.token,
            title:this.form.name,
            parentId:''
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
            this.addbranch = false;
            this.addclassloading = false;
              // this.addcll = ''
              this.form.name = ''
              this.$message({
                showClose: true,
                message: '添加部门成功',
                type: 'success'
              });
              // this.classlist()
              this.tree()
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    // 删除部门
    deldepart(departid){
      console.log('部门id:'+departid);
      console.log(this.departid);
      this.$confirm('确定要删除当前部门吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/structure/del', {
            params: {
              sec: localStorage.token,
              id:departid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              // this.classlist();
              // this.departlist();
              // this.departlistthree(this.departid)
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.tree()
              this.userlist()//人员列表
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    // 打开编辑部门
    editdepart(){
        this.edit = true;
        // this.departid = departid;//当前部门id
        // this.placetitle = title;
        // console.log("点击的部门id："+this.departid);
        this.ischangebtn = true;
        this.isdisabled = false;
        // this.departlist()//加载职位列表
        this.tree()
    },
    renderContent(h, { node, data, store }) {
      console.log(node);
        return (
          <span class="custom-tree-node">
            <span>{node.label}</span>
            <span>
              <el-button size="mini" type="text" on-click={ () => this.treeappend(data) }>添加</el-button>
              <el-button size="mini" type="text" on-click={ () => this.treeedit(node, data) }>编辑</el-button>
              <el-button size="mini" type="text" on-click={ () => this.treeremove(node, data) }>删除</el-button>
            </span>
          </span>);
    },
    // 添加树
    treeappend(data) {
      this.innerVisible=true
      console.log(data);
      this.treeappendid = data.id;
      this.departmenttreeexpanded.push(data.id)
      // const newChild = { id: id++, label: 'testtest', children: [] };
      // if (!data.children) {
      //   this.$set(data, 'children', []);
      // }
      // data.children.push(newChild);
    },
    // 删除树
    treeremove(node, data) {
      console.log(node);
      console.log(data);
      // const parent = node.parent;
      // const children = parent.childNodes || parent
      // const index = children.findIndex(d => d.id === data.id);
      // children.splice(index, 1);
      this.deldepart(data.id)
    },
    // 编辑树
    treeedit(node,data){
      console.log(node);
      console.log(data);
      this.innerVisibletwo=true;
      this.treedeitid=data.id;
    },
    // 编辑树2
    changetreename(){
      if(this.newname == ''){
        this.nonewname = true;
      }else{
        this.nonewname = false;
        // this.addclassloading=true;
        axios.get('/admin/structure/edit', {
          params: {
            sec: localStorage.token,
            id:this.treedeitid,
            title:this.newname
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
            // this.addbranch = false;
            // this.addclassloading = false;
            //   this.ischangebtn = false;
            //   this.isdisabled = true
              this.$message({
                showClose: true,
                message: '修改部门成功',
                type: 'success'
              });
              // this.classlist()
              this.tree()
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    // 树 数据源
    tree(){
      axios.get('/admin/structure/treeList', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.treedata = response.data.data.list
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    renderContenttwo(h, { node, data, store }) {
        // console.log(data);
        if(data.pid=='0'){
          return (
            <span class="custom-tree-node">
              <span>{node.label}</span>
              <span>
                <el-button size="mini" type="text" on-click={ () => this.storetreeadd(data) }>添加</el-button>
                <el-button size="mini" type="text" on-click={ () => this.storetreeedit(node, data) }>编辑</el-button>
                <el-button size="mini" type="text" on-click={ () => this.treeremovestore(node, data) }>删除</el-button>
              </span>
            </span>);
        }else{
          return (
            <span class="custom-tree-node">
              <span>{node.label}</span>
              <span>
                <el-button size="mini" type="text" on-click={ () => this.storetreeedit(node, data) }>编辑</el-button>
                <el-button size="mini" type="text" on-click={ () => this.treeremovestore(node, data) }>删除</el-button>
              </span>
            </span>);
        }

    },
    // 编辑部门、职位名称
    changedepart(type,positionid){
      console.log(type);
      console.log(positionid);
      console.log(this.departid);
      if(type== 1){
        if(this.formtwo.name == ''){
          this.descthree = true;
        }else{
          this.descthree = false;
          this.addclassloading=true;
          axios.get('/learn/organization/edit', {
            params: {
              sec: localStorage.token,
              id:this.departid,
              title:this.formtwo.name
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.addbranch = false;
              this.addclassloading = false;
                this.ischangebtn = false;
                this.isdisabled = true
                this.$message({
                  showClose: true,
                  message: '修改部门成功',
                  type: 'success'
                });
                // this.classlist()
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
        }
      }//部门结束
      // 职位开始
      if(type== 2){
        if(this.modifyok == ''){
          this.isshowpositiondesc = true;
        }else{
          this.isshowpositiondesc = false;
          this.addclassloading=true;
          axios.get('/learn/organization/edit', {
            params: {
              sec: localStorage.token,
              id:positionid,
              title:this.modifyok
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.addclassloading = false;
              this.isshowpositiontitle = true ;
              this.modifyinput = '';
              this.$message({
                showClose: true,
                message: '修改职位成功',
                type: 'success'
              });
              // this.departlist()
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
        }
      }//部门结束
    },
    // 添加三级分类
    addsubset(){
      this.innerVisible=false;
      if(this.subsetname == ''){
        this.subsetnoname = true;
      }else{
        this.subsetnoname = false;
        // this.addclassloading=true;
        axios.get('/admin/structure/add', {
          params: {
            sec: localStorage.token,
            title:this.subsetname,
            parentId:this.treeappendid
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
            this.addclassloading = false;
              // this.formtwo.position = '';
              this.$message({
                showClose: true,
                message: '添加职位成功',
                type: 'success'
              });
              this.subsetname=''//清空输入框
              // this.departlistthree(this.departid)//父级id
              this.tree()
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    // 职位列表
    departlist(){
      axios.get('/learn/organization/list', {
        params: {
          sec: localStorage.token,
          parentId:this.departid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            // console.log(response.data.data.list);
            this.showdepartlist = response.data.data.list;//职位列表数据
            console.log(response.data.data.list.length);
            this.numnumthree = response.data.data.list.length;
            for(var i=0;i<response.data.data.list.length;i++){
              // this.departlistthree(response.data.data.list[i].id)
            }
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 三级列表
    departlistthree(id){
      console.log(id);
      axios.get('/learn/organization/list', {
        params: {
          sec: localStorage.token,
          parentId:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            // console.log(response.data.data.list);
            this.showdepartlistthree = response.data.data.list;//职位列表数据
            console.log(this.numnumthree);
            for(i=0;i<this.numnumthree;i++){

            }
            console.log(this.showdepartlistthree);
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 编辑职位
    editposition(positionid){
      console.log(positionid);
      this.isshowpositiontitle = positionid;
      this.modifyinput = positionid;
      this.modifyok = ''
    },
    // 取消修改
    canceledit(){
      this.modifyinput = '';
      this.isshowpositiontitle = true;
    },
    // 查询部门人员
    changegroup(departid){
      console.log(departid);
      this.allmainproloading = true;
      this.userlist(departid)
    },
    // 查询全部人员
    allperson(){
      this.notraindelete = true;
      this.yestraindelete = false;
      this.allmainproloading = true;
      this.userlist()
    },
    // 人员列表
    trainuserlist(departid){
      console.log('人员列表接的参数：'+departid);
      axios.get('/admin/member/list', {
        params: {
          sec: localStorage.token,
          jobId:departid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.tableDatatrain = response.data.data.list;//培训班添加人员列表
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 人员列表
    userlist(departid){
      console.log('人员列表接的参数：'+departid);
      axios.get('/admin/member/list', {
        params: {
          sec: localStorage.token,
          jobId:departid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.allmainproloading = false;//取消加载框
            this.tableData = response.data.data.list;//table数据源
            this.tableDatalength = response.data.data.list.length;//table数据源
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 下拉框选择部门
    changeselect(departid){
      this.departid = departid;
      console.log('选中的部门id：'+this.departid);
      // this.departlist()
    },
    // 获取职位id
    changeposition(positionid){
      this.positionid = positionid;
      console.log('选中的职位id：'+this.positionid);
    },
    // 添加成员
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 验证通过
          console.log(this.departid);
          console.log(this.positionid);
          console.log(this.adduserform.tel);
          console.log(this.adduserform.name);
          console.log(this.adduserform.gender);
          console.log(this.adduserform.date1);
          console.log(this.logarr);
          console.log(this.positionid);
          axios.get('/admin/member/add', {
            params: {
              sec: localStorage.token,
              // department:this.departid,
              // job:this.positionid,
              phone:this.adduserform.tel,
              username:this.adduserform.name,
              gender:this.adduserform.gender,
              entry:this.adduserform.date1,
              jobId:this.positionid,
              per:this.logarr,
              regionid:this.areaid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
                this.addusertoast = false;
                this.$message({
                  showClose: true,
                  message: '添加成员成功',
                  type: 'success'
                });
                //加载人员列表
                this.userlist()
                // this.classlist()// 加载部门列表
                // 清空表单数据
                this.adduserform.depart = '';
                this.adduserform.position = '';
                this.adduserform.tel = '';
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑人员
    edittablelist(row){
      console.log('当前人员的全部信息：'+JSON.stringify(row));

      this.addDialogVisible=true
      this.treeexpanded=[]// 默认展开
      this.editusertoast = true;
      this.treechecknowtwo=[]//默认选中
      console.log('默认选中：'+this.treechecknowtwo);
      console.log('默认选中：'+this.treechecknowtwo);
      console.log('默认展开：'+this.treeexpanded);
      this.positionid=''
      this.userlistid = row.id;//人员id

      this.edituserform.name = row.username;
      this.edituserform.tel = row.phone;
      this.edituserform.gender = row.gender;
      this.edituserform.date1 = row.entry_date;
      this.morenchecken = [];
      this.morenshow = [];
      this.morenchecken.push(row.jobid);
      this.morenshow.push(row.jobid)
      console.log(this.morenshow);
      console.log(this.morenchecken);
      this.logarr = row.per;
      this.treechecknow = row.per;

      this.getstoredata()
      this.edituserform.area = row.region_pid;
      this.areaget(this.edituserform.area)
      this.edituserform.areatwo = row.regionid;
    },
    closeremove(){
      this.$nextTick(() => {
      	this.$refs.treeeditref.setCheckedKeys([]);
      });
      this.editusertoast=false
      this.addDialogVisible=false
    },
    // 关闭编辑弹窗
    // handleClose(){
    //   console.log('00');
    // },
    // 删除人员
    removetablelist(tablelistid,type){//type0是批量
      console.log('人员id：'+tablelistid);
      let nowtablelistid = [];//临时人员id
      if(type == 1){
        nowtablelistid = tablelistid
        console.log(nowtablelistid);
        this.removetableall(nowtablelistid)
      }
      if(type == 0){
        nowtablelistid = this.checkeduserid
        console.log(nowtablelistid);
        if(nowtablelistid.length != 0){
          this.removetableall(nowtablelistid)
        }else{
          this.$message({
            showClose: true,
            message:'请选择需要批量删除的人员' ,
            type: 'error'
          });
        }
      }

    },
    // 删除
    removetableall(nowtablelistid){
      console.log(nowtablelistid);
      this.$confirm('确定要删除当前用户吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/member/del', {
            params: {
              sec: localStorage.token,
              id:nowtablelistid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.userlist();
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              // this.classlist()//部门列表
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    //从培训班删除
    removetablelisttrain:function(nowtablelistid){
      console.log(nowtablelistid);
      console.log('培训班id：'+this.traindeleteuserid);
      this.$confirm('确定要从培训班删除当前用户吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/temp/delMember', {
            params: {
              sec: localStorage.token,
              id:nowtablelistid,
              tempId:this.traindeleteuserid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.userlist();
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              // this.classlist()//部门列表
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    // 确认编辑
    edituserok(formName){
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
          // this.closeremove()
          console.log('选中的部门id：'+this.departid);
          console.log('选中的职位id：'+this.positionid);
          console.log(this.userlistid);
          axios.get('/admin/member/edit', {
            params: {
              sec: localStorage.token,
              id:this.userlistid,
              phone:this.edituserform.tel,
              username:this.edituserform.name,
              gender:this.edituserform.gender,
              entry:this.edituserform.tate1,
              jobId:this.positionid,
              per:this.logarr,
              regionid:this.areaid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.editusertoast = false;
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
              });
              this.userlist()
              // this.classlist()//部门列表
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
         // }else{
         //  console.log('error submit!!');
         //  return false;
      //   }
      // });
    },
    // 获取选中人员id
    handleRowChange(val){
      this.checkeduserid=[]
      console.log(this.$refs.multipleTable.selection);
      for(var i=0;i<val.length;i++){
        console.log(val[i].id);
        this.checkeduserid.push(val[i].id);
      }
      console.log(this.checkeduserid);
    },
    //添加到培训班
    addtotrain:function(){
      axios.get('/admin/temp/addMember', {
        params: {
          sec: localStorage.token,
          tempId:this.addtotrainid,
          ids:this.checkeduserid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.addtotraintoast = false;
            this.$message({
              showClose: true,
              message: '添加成功',
              type: 'success'
            });
            //加载人员列表
            console.log(this.addtrainid);
            this.trainuser(this.addtrainid)//对应人员列表
            // 清空表单数据
            this.trainadduserid = [];
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 点击人员行即选中
    clickrow(row,col,event){
      row.flag = !row.flag;
      this.$refs.multipleTable.toggleRowSelection(row,row.flag);
    },
    // 批量删除弹窗
    batchremove(){
      this.$confirm('确定要删除这些人员吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/learn/organization/del', {
            params: {
              sec: localStorage.token,
              id:departid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              // this.classlist();
              // this.departlist();
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    // 人员上线
    addusermax(){
      // if(this.all_num<this.max_num){
        this.addusertoast=true;
        this.positionid='';
        this.adduserform.name = '';
        this.adduserform.tel = '';
        this.adduserform.gender = '';
        this.adduserform.tate1 = '';
        this.logarr = [];
      // }else{
      //   this.$alert('当前人员管理总数已到上限，如需继续添加请致电16645142250', '', {
      //    confirmButtonText: '确定'
      //  });
      // }
    },
    //培训班列表
    trainlist:function(){
      axios.get('/admin/temp/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.traindata = response.data.data.list;//table数据源
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //编辑培训班
    trainedit:function(row){
      console.log(row);
      console.log(row.title);
      this.addtraintoast = true;
      this.isaddtrain = false;
      this.isedittrain = true;
      this.trainform.name = row.title;
      this.edittrainid = row.id;
    },
    //确认编辑
    edittrain:function(){
      axios.get('/admin/temp/edit', {
        params: {
          sec: localStorage.token,
          id:this.edittrainid,
          title:this.trainform.name
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.addtraintoast = false;
            this.$message({
              showClose: true,
              message: '编辑成功',
              type: 'success'
            });
            //加载人员列表
            this.trainlist()
            // 清空表单数据
            this.trainform.name = '';
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 删除培训部
    trainremove:function(id,title){
      this.$confirm('确定要删除 ' + title + '吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/temp/del', {
            params: {
              sec: localStorage.token,
              id:id
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              // this.classlist();
              // this.departlist();
              // this.departlistthree(this.departid)
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.trainlist()
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {

        });
    },
    //添加培训班
    addtrain:function(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 验证通过

          axios.get('/admin/temp/add', {
            params: {
              sec: localStorage.token,
              title:this.trainform.name
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
                this.addtraintoast = false;
                this.$message({
                  showClose: true,
                  message: '添加成功',
                  type: 'success'
                });
                //加载人员列表
                this.trainlist()//培训班列表
                // 清空表单数据
                this.trainform.name = '';
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //培训班人员
    trainuser:function(id){
      this.traindeleteuserid = id;
      this.notraindelete = false;
      this.yestraindelete = true;
      axios.get('/admin/temp/memberList', {
        params: {
          sec: localStorage.token,
          tempId:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.tableData = response.data.data.list;//table数据源
            this.tableDatalength = response.data.data.list.length;//table数据源
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //添加成员
    trainadd:function(id){
      this.addtraintoastuser = true;
      this.addtrainid = id;
    },
    //获取培训班选中人员
    gettrainusername:function(val){
      console.log(val);
      this.trainadduserid = val;
    },
    //添加培训班成员
    adddepartuser:function(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 验证通过

          axios.get('/admin/temp/addMember', {
            params: {
              sec: localStorage.token,
              tempId:this.addtrainid,
              ids:this.trainadduserid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
                this.addtraintoastuser = false;
                this.$message({
                  showClose: true,
                  message: '添加成功',
                  type: 'success'
                });
                //加载人员列表
                console.log(this.addtrainid);
                this.trainuser(this.addtrainid)//对应人员列表
                // 清空表单数据
                this.trainadduserid = [];
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style>
.x-person-left{
  height: 740px;
  position: relative;
}.x-per-lebg{
  background-color: #BDA17A;
  text-align: center;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px 5px 20px;
}.x-person-name{
  color: #BDA17A;
  background-color: #fff;
  padding: 5px 10px;
  margin: auto;
  border-radius: 24px;
  margin: 10px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 1rem;
}.x-per-li{
  display: flex;
  display: -webkit-flex;
  display: -webkit-box;
  padding: 20px 0;
  text-align: left;
  height: 34px;
  line-height: 34px;
  border-bottom: 1px solid #eee;
  height: auto;
  cursor: pointer;
}.x-three-box .x-per-li{
  display: block;
}.x-per-li .x-list-lll{
  display: flex;
  display: -webkit-flex;
  display: -webkit-box;
}.x-three-li .x-list-lll{
  margin-left: 40px;
  margin-top: 10px;
}
ul{
  margin: 0;
  padding: 0;
}.x-perli-item{
  flex: 1;
  -webkit-flex: 1;
  -webkit-box-flex: 1;
  font-size: 14px;
  color: #A6A6A6;
}.x-font-danger{
  color: #FF4D4D;
}.x-ac-modyfy,.x-icon-go,.x-icon-remove{
    margin-right: 10px;
    width: 14px;
    height: 14px;
    display: inline-block;
    vertical-align: middle;
}.x-ac-modyfy{
    background: url(../images/add.png)no-repeat;
    background-size: contain;
}.x-icon-go{
    background: url(../images/iconuser1.png)no-repeat;
    background-size: contain;
}.x-icon-remove{
    background: url(../images/iconuser2.png)no-repeat;
    background-size: contain;
}
.x-btn {
    background-color: #BDA17A;
    font-size: 14px;
    color: #fff;
    text-align: center;
    height: 44px;
    line-height: 44px;
    width: 126px;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    margin-right: 20px;
    z-index: 0;
}.x-btn-bl, .x-btn-bl2 {
    background-color: #BDA17A;
}.x-person-btn{
  width:200px;
  margin-top: 10px;
}.x-border-bottom{
  /* margin-left: 80px; */
  max-height: 300px;
  overflow-y: scroll;
}.el-input--small .el-input__inner{
  margin: 0;
}.x-only .x-css-label .el-form-item__content {
  display: flex;
  justify-content: space-between;
}
</style>
<style media="screen">

.x-addb-hed .el-dialog__header{
  background-color: #BDA17A;
}.x-addb-hed .el-dialog__header .el-dialog__title{
  color: #fff;
  font-size: 16px;
}.x-addb-hed .el-dialog{
border-radius: 15px;
}.x-addb-hed .el-dialog__header{
  border-top-left-radius: 11px;
  border-top-right-radius: 11px;
}.x-addb-hed .el-dialog__header .el-dialog__headerbtn .el-dialog__close{
  color: #fff;
  font-size: 20px;
}.x-btn{
  margin-right: 0!important;
}.x-desc{
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  left: 0px;
  bottom: -20px;
}.x-input-box{

}.x-css-btn{
  margin-left: 15px;
}.x-input-box .el-input__inner{
  line-height: 44px;
  height: 44px;
}.x-css-label .el-form-item__label{
  line-height: 44px;
}.x-css-footer{
  text-align: center;
}.el-form .el-form-item.x-css-label.el-form-item--small:last-child{
  margin-bottom: 0;
}.el-form .el-form-item.x-css-label.el-form-item--small{
  margin-bottom: 40px;
}.x-edit-box{
  flex: 1;
  -webkit-flex: 1;
  -webkit-box-flex: 1;
  position: relative;
}.x-edit-box .x-modify-k{
  width: 200px;
}.x-ri-title{
  color: #3F3F3F;
  font-size: 16px;
  font-weight: 600;
  margin: 30px 0;
  border-bottom: 1px solid #ddd;
  padding-bottom: 20px;
}.x-right-table{
  font-size: 15px;
}.x-right-table .el-table__header-wrapper{

}.el-table.x-right-table thead{
  color: #A6A6A6;
}.x-btn-left {
    /* float: left; */
}.x-btn-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}.x-all-btn {
    margin: 30px 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}.x-btn-bl, .x-btn-bl2 {
    background: #BDA17A;
}.x-search-icon {
    background: url(../images/search.png)no-repeat;
    background-size: contain;
    width: 16px;
    margin-right: 8px;
    display: inline-block;
    line-height: 16px;
    height: 16px;
    vertical-align: text-bottom;
}.x-btn-right .x-search-input{
  width: auto;
  margin-right: 10px;
  /* float: left; */
}.x-btn-right .input-group-append{
  float: right;
}.x-btn-right .x-search-input .el-input__inner{
  width: auto;
}.x-nothing{
  color: #ccc;
  background-color: red;
  font-size: 16px;
}.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }.x-tree-title{
    font-size: 15px;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;
  }.x-tree-title span{
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 2px;
    width: 80px;
    margin: auto;
    display: block;
    margin-top: 6px;
  }.x-tree-desc{
    color: #999;
    text-align: left;
    display: block;
    font-size: 12px;
  }.x-back-per{
    width: 24px;
    display: block;
    margin-bottom: 10px;
    cursor: pointer;
  }.x-person-right{
    background-color: #fff;
    padding: 0 10px;
  }.x-addclass-box{
    padding: 10px;
  }.x-tree-title{
    background-color: #BDA17A;
    color: #fff;
    text-align: center;
    padding: 10px 5px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: block;
  }.x-person-left{
    background-color: #fff;
    height: 800px;
  }.x-per-descc{
    text-decoration: none;
    background-color: #fff;
    padding: 6px 15px;
    color: #606266;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/personmanage.vue